import ManualAssignmentModal from './ManualAssignmentModal';

export default ManualAssignmentModal;
